export default class CookieBanner {
  constructor(elem, APP) {
    this.elem = elem;
    this.acceptButton = this.elem.querySelector(".js-cookie-accept");
    this.rejectButton = this.elem.querySelector(".js-cookie-reject");
    this.analyticsAttr = `ga-disable-${options.google_analytics_id}`;
    // this.tagAttr = `ga-disable-${options.google_tag_manager_id}`;
  }

  setCookie() {
    let expiry = new Date();
    expiry.setMonth(expiry.getMonth() + 6);
    document.cookie =
      "mlp_cookie_policy=true; expires=" + expiry.toUTCString() + "; path=/";
  }

  hasCookie() {
    return document.cookie.includes("mlp_cookie_policy");
  }

  enableTracking() {
    window[this.analyticsAttr] = false;
  }

  disableTracking() {
    window[this.analyticsAttr] = true;
  }

  hideUI() {
    this.elem.remove();
  }

  showUI() {
    this.elem.style.display = "block";
  }

  init() {
    // toggle cookie UI based on the cookie
    if (this.hasCookie()) {
      this.hideUI();
      this.enableTracking();
    } else {
      this.showUI();
      this.disableTracking();
    }

    // accept button handler
    this.acceptButton.addEventListener("click", () => {
      this.setCookie();
      this.hideUI();
      this.enableTracking();
    });

    // reject button handler
    this.rejectButton.addEventListener("click", () => {
      this.disableTracking();
      this.hideUI();
    });
  }
}
